export default {
  // 页面标题
  title: '活动列表',
  // 顶部操作
  addActivity: '添加活动',
  sortLevelTooltip:
    '优先级说明：数字越大优先级越高。如果二维码分布在多个活动中，消费者扫码将优先进入优先级更高的活动。',
  // 搜索区
  activityName: '活动名称',
  activityNamePlaceholder: '请输入活动名称',
  activityId: '活动ID',
  activityIdPlaceholder: '请输入活动ID',
  activityNo: '活动编号',
  activityNoPlaceholder: '请输入活动编号',
  activityStatus: '活动状态',
  activityStatusPlaceholder: '全部',
  search: '搜索',
  reset: '重置',
  // 状态
  statusAll: '全部',
  statusNotStarted: '未开始',
  statusActive: '进行中',
  statusEnded: '已结束',
  statusDisabled: '已禁用',
  // 表格列
  colActivityId: '活动ID',
  colActivityCode: '活动编号',
  colActivityName: '活动名称',
  colActivityTime: '活动时间',
  colStatus: '状态',
  colSortLevel: '优先级',
  colRemark: '活动备注',
  colCreateTime: '创建时间',
  colAction: '操作',
  // 操作
  actions: '操作',
  detail: '详情',
  edit: '编辑',
  disable: '禁用',
  enable: '启用',
  delete: '删除',
  // 时间范围
  timeRangeSep: '至',
  // 排序编辑
  sortLevelPlaceholder: '请输入排序值',
  // 确认弹窗
  confirmDeleteTitle: '确认删除',
  confirmDeleteContent: '确定要删除该活动吗？删除后不可恢复。',
  confirmToggleTitle: '确认操作',
  confirmDisableContent: '确定要禁用该活动吗？',
  confirmEnableContent: '确定要启用该活动吗？',
  // 空状态
  emptyText: '暂无活动数据',
};
